import { EntryShared } from '../../../shared/scripts/EntryShared.ts';
import { Scene } from './UISceneTypes.ts';
export function sendDiscordScenePageVisitAnalytic(scene) {
    if (scene == Scene.Game) return;
    let pathName;
    switch(scene){
        case Scene.LandingPage:
        case Scene.MainPage:
            pathName = '/';
            break;
        case Scene.Lobby:
            pathName = '/lobby';
            break;
        case Scene.Room:
            pathName = '/room';
            break;
        case Scene.DiscordLeaderboard:
            pathName = '/leaderboards';
            break;
        case Scene.DiscordStore:
            pathName = '/store';
            break;
        case Scene.DiscordAbout:
            pathName = '/about';
            break;
        case Scene.DiscordCareers:
            pathName = '/careers';
            break;
        case Scene.DiscordChampionship25:
            pathName = '/championship2025';
            break;
        case Scene.DiscordChampionship26:
            pathName = '/championship2026';
            break;
        case Scene.DiscordCommunity:
            pathName = '/community';
            break;
        case Scene.DiscordFAQ:
            pathName = '/faq';
            break;
        case Scene.DiscordPrivacyPolicy:
            pathName = '/privacy-policy';
            break;
        case Scene.DiscordPatchNotes:
            pathName = '/patch-notes';
            break;
        case Scene.DiscordProfile:
            pathName = '/profile';
            break;
        case Scene.DiscordGifting:
            pathName = '/gifting';
            break;
        case Scene.DiscordValues:
            pathName = '/values';
            break;
        case Scene.DiscordValuesExamples:
            pathName = '/values-examples';
            break;
        case Scene.DiscordTerms:
            pathName = '/terms';
            break;
        case Scene.DiscordPressKit:
            pathName = '/press-kit';
            break;
        case Scene.DiscordRefundPolicy:
            pathName = '/refund-policy';
            break;
        case Scene.DiscordReplay:
            pathName = '/replay';
            break;
        case Scene.DiscordMore:
            pathName = '/more';
            break;
    }
    EntryShared.sendPageVisitAnalyticEvent(pathName);
}
